import { AxiosResponse } from "axios";
import axiosInstance from "../../../../interceptors/axiosInstance";
import { Iprops, UpdateCobranzaJudicialDTO } from "../models/cobranzaJudicial";


export async function getCobranzaJudicial(params: Iprops): Promise<AxiosResponse> { 
    const response: AxiosResponse = await axiosInstance.get(
        "siscred-api-maestros/v1/cobranzajudicial/listar",
        { params }
    );
    return response;
}

export async function updateCobranzaJudicial(params:UpdateCobranzaJudicialDTO[]) {
    let requestParams = { items : params };
    const response: AxiosResponse = await axiosInstance.post('siscred-api-maestros/v1/cobranzajudicial/actualizar-masivo', requestParams);
    
    return response;
}

export async function validarCobranzaJudicial(idMutuo: number): Promise<AxiosResponse> {
    const response: AxiosResponse = await axiosInstance.get(
        "siscred-api-maestros/v1/cobranzajudicial/validar",
        { params: { idMutuo } }
    );
    return response;
}

